import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
// Component
import { EmptyText } from '../Common/CellText'
import NormalTag from '../NormalTag/NormalTag'
// Styled component
import {
  PopoverItem,
  PopoverList,
  PopoverTitle,
  TagWrapper,
  ViewLogModal,
} from './PopoverWatchTimeStyled'
// Ant design
import {
  BankOutlined,
  EyeInvisibleOutlined,
  EyeOutlined,
  HistoryOutlined,
  TeamOutlined,
  UserOutlined,
} from '@ant-design/icons'
import { Popover } from 'antd'
// Other
import { inject, observer } from 'mobx-react'
import { useState } from 'react'
import { v4 } from 'uuid'
import { blue, green, yellowPrimary } from '../../color'
import { ASSIGNEE_TYPE } from '../../constants'
import date_format from '../../date_format'
import useOpenItem from '../../hooks/useOpenItem'
import { UserGroupRequest } from '../../requests/UserGroupRequest'
import authenticationStore from '../../stores/authenticationStore'
import utils from '../../utils'
import SpinnerInlineComponent from '../SpinnerInlineComponent'

const findAssigneeType = assigneeType => {
  switch (assigneeType) {
    case ASSIGNEE_TYPE.USER:
      return <UserOutlined style={{ color: blue, marginRight: 6 }} />
    case ASSIGNEE_TYPE.DEPARTMENT:
      return <BankOutlined style={{ color: green, marginRight: 6 }} />
    case ASSIGNEE_TYPE.GROUP:
      return <TeamOutlined style={{ color: yellowPrimary, marginRight: 6 }} />
    default:
      return <UserOutlined style={{ color: blue, marginRight: 6 }} />
  }
}
const findTextColor = assignee_type => {
  return assignee_type === ASSIGNEE_TYPE.USER
    ? blue
    : assignee_type === ASSIGNEE_TYPE.DEPARTMENT
    ? green
    : yellowPrimary
}

const PopoverWatchTime = props => {
  const {
    userList,
    title,
    showFullTag,
    internalDocumentStore,
    selectPeopleStore,
    isFullViewer,
    typeId,
    compared_date,
    created_at = '',
    departWithUsers,
  } = props

  const { viewLogList, setViewLogList, getViewLog } = internalDocumentStore
  const {
    isOpen: isVisibleViewLog,
    handleOpen: handelVisibleLogView,
    handleClose: handleCancelLogView,
  } = useOpenItem()
  const [isOpenPopoverList, setIsOpenPopoverList] = useState(false)
  const [users, setUsers] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [groupMembersMap, setGroupMembersMap] = useState({})

  const fetchGroupMembers = async groupAssignees => {
    if (!groupAssignees?.length) return
    const results = await Promise.all(
      groupAssignees.map(async g => {
        try {
          const res = await UserGroupRequest.getMemberGroupByIdGroup(
            g.id,
            0,
            100
          )
          return { id: g.id, members: res.data.data || [] }
        } catch {
          return { id: g.id, members: [] }
        }
      })
    )
    const map = {}
    results.forEach(({ id, members }) => {
      map[id] = members
    })
    setGroupMembersMap(map)
  }

  const handlePopoverList = async value => {
    setIsOpenPopoverList(value)
    if (value) {
      setViewLogList([])
      setIsLoading(true)
      const groupAssignees =
        userList?.filter(item => item.assignee_type === ASSIGNEE_TYPE.GROUP) ||
        []
      await Promise.all([
        fetchGroupMembers(groupAssignees),
        handleGetViewLog(groups || []),
      ]).finally(() => setIsLoading(false))
    }
  }
  // userList có dạng:
  // userList = [
  //   {
  //     assignee_type: "USER"
  //     full_name: "ĐỖ ĐỨC ÂN"
  //     id: "andd"
  // last_date_read
  //     permission: "LEAD"
  //   }
  //   ...
  // ]
  const createdAt = new Date(created_at)
  const comparedDate = new Date(compared_date)

  const groups = userList?.filter(
    item => item.assignee_type !== ASSIGNEE_TYPE.USER
  )

  const usersPre = userList?.filter(
    item => item.assignee_type === ASSIGNEE_TYPE.USER
  )

  useEffect(() => {
    if (!selectPeopleStore.originDepartmentWithUserList?.length) {
      selectPeopleStore.getDepartmentWithUsers(
        authenticationStore.currentCompanyCode()
      )
    }
  }, [])

  useEffect(() => {
    const usersNotYet = usersPre?.filter(
      item =>
        !(
          viewLogList?.filter(
            log =>
              (log.username === item.username || log.username === item.id) &&
              item.assignee_type !== ASSIGNEE_TYPE.USER
          )?.length > 0
        )
    )
    setUsers(usersNotYet)
  }, [viewLogList])

  const handleGetViewLog = async groups => {
    const supportedTypes = [ASSIGNEE_TYPE.GROUP, ASSIGNEE_TYPE.DEPARTMENT]
    const calls = (groups || [])
      .filter(group => supportedTypes.includes(group.assignee_type))
      .map(group =>
        getViewLog({
          assignee_code: group.id,
          assignee_type: group.assignee_type,
          document_code: typeId,
        })
      )
    if (usersPre?.length) {
      calls.push(
        getViewLog({
          assignee_code: usersPre.map(user => user.id).join(','),
          assignee_type: ASSIGNEE_TYPE.USER,
          document_code: typeId,
        })
      )
    }
    await Promise.all(calls)
  }

  const expandGroupOrDept = item => {
    if (item.assignee_type === ASSIGNEE_TYPE.GROUP) {
      const members = groupMembersMap[item.id] || []
      if (members.length) {
        return members.map(member => {
          const vl = viewLogList.find(
            log =>
              String(log.groupId) === String(item.id) &&
              log.username === member.user?.user_name
          )
          return {
            username: member.user?.user_name,
            full_name: member.user?.name_lowercase,
            assignee_type: ASSIGNEE_TYPE.USER,
            first_date_read: vl?.first_date_read,
          }
        })
      }
    }
    if (item.assignee_type === ASSIGNEE_TYPE.DEPARTMENT) {
      const deptData = selectPeopleStore.originDepartmentWithUserList?.find(
        d => d.code === item.id
      )
      if (deptData?.users?.length) {
        return deptData.users.map(user => {
          const vl = viewLogList.find(
            log =>
              String(log.groupId) === String(item.id) &&
              (log.username === user.user_name ||
                log.username === user.user_code)
          )
          return {
            username: user.user_name,
            full_name: user.name_uppercase?.toLowerCase(),
            assignee_type: ASSIGNEE_TYPE.USER,
            first_date_read: vl?.first_date_read,
          }
        })
      }
    }
    return [item]
  }

  const popoverList = (listSelected, selectGroup) => {
    let key = v4()
    return (
      <PopoverList key={key}>
        <div className={'popover-head'}>
          {selectGroup ? (
            <span
              style={{
                color: findTextColor(selectGroup.assignee_type),
                textTransform: 'capitalize',
                marginLeft: selectGroup ? '8px' : 0,
                maxWidth: 300,
              }}>
              {findAssigneeType(selectGroup.assignee_type)}
              {(selectGroup?.full_name ?? selectGroup?.name)?.toLowerCase()}
            </span>
          ) : (
            <b>
              <UserOutlined style={{ color: blue, marginRight: 6 }} />
              Người dùng
            </b>
          )}

          <b style={{ display: 'inline-block', width: 132 }}>
            <HistoryOutlined style={{ color: blue, marginRight: 6 }} />
            Thời gian xem
          </b>
        </div>

        {listSelected?.length > 0 ? (
          listSelected.map((el, index) => {
            let type = findAssigneeType(el?.assignee_type)
            let name
            let userInfo = utils.getInfoUser(
              el?.username,
              departWithUsers
                ? departWithUsers
                : selectPeopleStore.originDepartmentWithUserList
            )

            let department = (
              userInfo?.full_name ??
              el?.full_name ??
              el?.name
            )?.toLowerCase()

            if (department) {
              name = department
            } else {
              let users = userList?.filter(
                user =>
                  user.id === el?.username || user.username === el?.username
              )
              if (users && users.length > 0) {
                name = users[0]?.full_name
                  ?.toLowerCase()
                  ?.replace(/(^|\s)\S/g, l => l?.toUpperCase())
              }
            }

            // if (name) {

            return (
              <PopoverItem key={index}>
                <span
                  style={{
                    color: blue,
                    textTransform: 'capitalize',
                    marginLeft: selectGroup ? '8px' : 0,
                  }}>
                  {type}
                  {name}
                </span>
                <time>
                  {isFullViewer && createdAt < comparedDate ? (
                    <span>
                      <EyeOutlined style={{ color: green, marginRight: 6 }} />
                      Đã xem
                    </span>
                  ) : el.last_date_read || el.first_date_read ? (
                    <span>
                      <EyeOutlined style={{ color: green, marginRight: 6 }} />
                      {date_format.HH_mm_DD_MM_YYYY(
                        el.last_date_read || el.first_date_read
                      )}
                    </span>
                  ) : (
                    <EmptyText>
                      <EyeInvisibleOutlined
                        style={{ color: '#ccc', marginRight: 6 }}
                      />
                      Chưa xem.
                    </EmptyText>
                  )}
                </time>
              </PopoverItem>
            )
            // } else {
            //   return <></>
            // }
          })
        ) : (
          <EmptyText>
            <span style={{ marginLeft: 12 }}>Không có.</span>
          </EmptyText>
        )}
        {isLoading && (
          <div style={{ height: 150, position: 'relative' }}>
            <SpinnerInlineComponent
              sizeSpin={'small'}
              tip="Đang tải dữ liệu..."
              isLoading={isLoading}
              backGround={'#ffffffc7'}
            />
          </div>
        )}
      </PopoverList>
    )
  }
  return (
    <>
      {isFullViewer ? (
        <TagWrapper
          onClick={async () => {
            setViewLogList([])
            setIsLoading(true)
            const groupAssignees =
              userList?.filter(
                item => item.assignee_type === ASSIGNEE_TYPE.GROUP
              ) || []
            await Promise.all([
              fetchGroupMembers(groupAssignees),
              handleGetViewLog(groups),
            ]).finally(() => setIsLoading(false))
            handelVisibleLogView()
          }}>
          <NormalTag
            noHover={true}
            showFullTag={showFullTag}
            tags={userList?.map(user =>
              (user?.full_name ?? user?.name)?.toLowerCase()
            )}
          />
        </TagWrapper>
      ) : (
        <Popover
          placement="top"
          content={() => {
            if (isLoading)
              return (
                <div style={{ height: 150, position: 'relative', width: 300 }}>
                  <SpinnerInlineComponent
                    sizeSpin={'small'}
                    tip="Đang tải dữ liệu..."
                    isLoading={true}
                    backGround={'#ffffffc7'}
                  />
                </div>
              )
            const groupItems =
              userList?.filter(
                item => item.assignee_type !== ASSIGNEE_TYPE.USER
              ) || []
            const userItems =
              userList?.filter(
                item => item.assignee_type === ASSIGNEE_TYPE.USER
              ) || []
            return (
              <>
                {groupItems.map(item =>
                  popoverList(expandGroupOrDept(item), item)
                )}
                {userItems.length > 0 && popoverList(userItems)}
              </>
            )
          }}
          title={<PopoverTitle>{title}</PopoverTitle>}
          visible={isOpenPopoverList}
          onVisibleChange={handlePopoverList}
          trigger="click"
          overlayClassName={'wrapper-list'}
          overlayStyle={{ maxWidth: '450px' }}>
          <TagWrapper>
            <NormalTag
              noHover={true}
              showFullTag={showFullTag}
              tags={userList?.map(user =>
                (user?.full_name ?? user?.name)?.toLowerCase()
              )}
            />
          </TagWrapper>
        </Popover>
      )}

      <ViewLogModal
        title={'Danh sách người xem'}
        width={550}
        style={{ top: 40 }}
        visible={isVisibleViewLog}
        closable={true}
        maskClosable={true}
        onCancel={() => {
          handleCancelLogView()
          setViewLogList([])
        }}
        footer={null}>
        {groups?.map(group => popoverList(expandGroupOrDept(group), group))}
        {usersPre?.length > 0
          ? popoverList(
              usersPre.map(user => {
                const vl = viewLogList.find(
                  log =>
                    log.username === user.id || log.username === user.username
                )
                return {
                  ...user,
                  first_date_read: vl?.first_date_read,
                  last_date_read: vl?.last_date_read,
                }
              })
            )
          : ''}
      </ViewLogModal>
    </>
  )
}

PopoverWatchTime.propTypes = {
  userList: PropTypes.array,
  title: PropTypes.string,
  showFullTag: PropTypes.bool,
}

export default inject(
  'internalDocumentStore',
  'selectPeopleStore'
)(observer(PopoverWatchTime))
